import script from "./siderLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./siderLayer.vue?vue&type=script&setup=true&lang=js"

import "./siderLayer.vue?vue&type=style&index=0&id=4a88e346&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a88e346"]])

export default __exports__